/**
 *
 * Asynchronously loads the component for ExamSetup
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const ExamSetup = lazyLoad(
  () => import('./index'),
  module => module.ExamSetup,
);
